module.exports = __webpack_public_path__ + "static/media/SongStart-Podcast-Cover-Art-1-1-768x768.77b6d85e.jpeg";